module.exports = __webpack_public_path__ + "images/mui.570de2fa.webp";